<script>
import { slideUp, slideDown } from '@/utils/motion';
export default {
  name: 'TransitionExpand',
  functional: true,
  render(createElement, context) {
    const data = {
      props: {
        name: 'expand',
      },
      on: {
        enter(element) {
          slideDown(element);
        },
        leave(element) {
          slideUp(element);
        },
      },
    };
    return createElement('transition', data, context.children);
  },
};
</script>
